import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "keilhauer" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_EXR_high_resolution",
        exportFormat: "exr",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_JPG_high_resolution",
        exportFormat: "jpeg",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_TIFF_high_resolution",
        exportFormat: "tiff",
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_PNG_high_resolution",
        exportFormat: "png",
        exportResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_EXR_low_resolution",
        exportFormat: "exr",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_JPG_low_resolution",
        exportFormat: "jpeg",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_TIFF_low_resolution",
        exportFormat: "tiff",
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_PBR_PNG_low_resolution",
        exportFormat: "png",
        exportResolution: "dpi72",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_Tileable_high_resolution.$IMAGE_FORMAT$",
        imageResolution: "original",
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Keilhauer_$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_Tileable_low_resolution.$IMAGE_FORMAT$",
        imageResolution: "px1000",
        options,
    },
]
